import React, { useEffect, useState } from 'react'
import InstructorResultCard from '../CardStyles/InstructorResultCard'
import { ResultsCount } from '../common/TopResultsSectionHeader'
import SortToggleFlexBox from '../common/SortToggleFlexBox'
import SearchSorting from 'components_v2/common/MenuDialog'
import styledComponents from 'styled-components'
import InfiniteScroll from 'react-infinite-scroll-component'
import { css } from '@styled-system/css'
import { Box } from 'ui/acro'
import axios from 'axios'
import AloMovesAnimation from '../common/AloMovesAnimation'

const InstructorsPage = styledComponents(Box)`
${css({
  // prevents scrollbars from showing
  '.infinite-scroll-component': {
    overflow: 'hidden !important'
  },
  '.instructors-grid': {
    display: 'grid',
    gridTemplateColumns: [
      'repeat(2, 1fr)',
      'repeat(7, 1fr)',
      'repeat(7, 1fr)',
      'repeat(7, 1fr)'
    ],
    gap: ['15px', '16px', '22px', '25px'],
    mb: '57px'
  }
})}
`

const InstructorResultsPage = ({ query }) => {
  const batchSize = 28
  const [sorting, setSorting] = useState('')
  const [data, setData] = useState([])
  const [hitCount, setHitCount] = useState(0)
  const [offset, setOffset] = useState(0)
  const [hasMore, setHasMore] = useState(false)
  const [refresh, setRefresh] = useState(0)

  const sort = (value) => {
    setSorting(value)
    setOffset(0)
    setData([])
    setRefresh(refresh + 1)
  }

  const fetchData = async () => {
    try {
      const params = { q: query, from: offset, sort: sorting, size: batchSize }
      const res = await axios.get(`api/v2/search/instructors`, { params })
      if (res && res.data && res.data.top) {
        setHitCount(res.data.result_count)
        setData((prevData) => [...prevData, ...res.data.top])

        if (res.data.top.length >= batchSize) {
          setHasMore(true)
          setOffset(res.data.top.length + offset)
        } else {
          setHasMore(false)
        }
      }
    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    fetchData()
  }, [refresh])

  const showSorting = hitCount > 3

  if (data && hitCount > 0) {
    return (
      <InstructorsPage>
        <SortToggleFlexBox
          flexDirection={['column', showSorting ? 'row-reverse' : 'row']}
        >
          {showSorting && (
            <SearchSorting applied={sort} location='search_instructors' />
          )}
          <ResultsCount>
            {hitCount} {hitCount !== 1 ? `instructors` : `instructor`}
          </ResultsCount>
        </SortToggleFlexBox>
        <InfiniteScroll
          className='instructors-grid'
          dataLength={data.length}
          next={() => {
            fetchData()
          }}
          hasMore={hasMore}
          loader={<AloMovesAnimation />}
        >
          {data.map((item, idx) => (
            <InstructorResultCard
              key={idx}
              name={item.name && item.name}
              url={item.url && item.url}
              thumbnailImage={item.thumbnail_image && item.thumbnail_image}
              altText={item.name && item.name}
            />
          ))}
        </InfiniteScroll>
      </InstructorsPage>
    )
  } else return <></>
}

export default InstructorResultsPage
